import tw from "tailwind-styled-components";

export default tw.footer<Record<string, unknown>>`
    bg-white-ish
    w-full
    flex
    bottom-0
    flex-col
    gap-6
    py-8
    sm:py-2
    items-center
    lg:flex-row
    lg:justify-between
    px-8
`